import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ClientFeatures } from '@models/configuration/model';
import { Observable } from 'rxjs';
import { CoreService } from '../models/clux/enum';
import { Uri } from '../utils/uri';
import { map } from 'rxjs';
import { ContactQuery } from '@app/state';

@Injectable({
  providedIn: 'root',
})
export class ClientFeaturesService {
  private http = inject(HttpClient);
  private contactQuery = inject(ContactQuery);

  private clientId: string;

  constructor() {
    this.clientId = this.contactQuery.getActive().clientId;
  }

  public getClientFeatures(): Observable<ClientFeatures> {
    const url = new Uri(`/profile/${this.clientId}/client/features`, CoreService.Configuration);
    return this.http.get<ClientFeatures>(url.toString());
  }

  public hasClientAccounts(): Observable<boolean> {
    return this.getClientFeatures().pipe(map((features) => features?.hasClientAccounts));
  }
}
